import React from 'react';
import { CognitiveFlowsProvider } from '../cognitive-flows/context/CognitiveFlowsContext';
import CognitiveFlowsTeamPage from '../cognitive-flows/pages/CognitiveFlowsTeamPage';

// Bridges the Cognitive Flows "Team & Workspaces" page into the main dashboard
// Settings ("Teams & Workspace" group). The CF page depends on the CF context +
// api client, so we mount its provider here (self-contained: it sets the CF API
// base from app_url and bootstraps /meta). Rendered inside Settings.jsx via
// React.createElement, which passes app_url.
export default function TeamWorkspaceSettings({ app_url, view = 'workspace' }) {
  return (
    <CognitiveFlowsProvider app_url={app_url}>
      <CognitiveFlowsTeamPage view={view} />
    </CognitiveFlowsProvider>
  );
}
